import React, { useState } from 'react';
import { connect } from 'react-redux'
import { Field, reduxForm} from 'redux-form';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import {
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Paper,
  Checkbox,
  CircularProgress
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Collapse from '@material-ui/core/Collapse';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';

import { useStyles } from './styles';
import { FormActionButtons } from "components";
import { useQuery } from '@apollo/react-hooks';
import { GET_ACTIVITY_RATE_PLANS} from 'graphql/queries/activities';


const RenderCheckbox = ({ input, meta, ...rest }) => {
  return (
    <Checkbox
      checked={input.value ? true : false}
      onChange={input.onChange}
      {...rest}
    />
  );
};

const ActivityFuturePrices = ({ 
    handleSubmit,
    setSubmitButton,
    isUpdate,
    onSubmit, 
    businessOwner
}) => {
  const [selectedRows, setSelectedRows] = useState({});
  const classes = useStyles();


   const { loading, data,error} = useQuery(GET_ACTIVITY_RATE_PLANS, { 
    variables: {
      businessOwnerId:
        businessOwner.selectedBusinessOwner.ownerId ||
        businessOwner.selectedBusinessOwner.id
    },
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true
  });
 
  const handleRowSelection = (ratePlanId) => {
    setSelectedRows(prev => ({
      ...prev,
      ratePlanId
    }));
  };


  const submitForm = (formValues) => {
  
    const selectedIds = Object.keys(formValues)
      .filter(key => key.startsWith('selected_') && formValues[key])
      .map(key => key.replace('selected_', ''));

    onSubmit({ futureRatePlanIds: selectedIds }, 'activityFuturePricesForm');
  };
  
  if (loading) return <CircularProgress />;
  if (error) return <Typography color="error">Error loading rate plans</Typography>;

  return (
    <form onSubmit={handleSubmit(submitForm)} className={classes.wrapper}>
      <Button
        className={classes.createNewBtn}
        onClick={() => (window.location.href = '/activity-rate-plan')}
      >
        <AddCircleOutlineIcon className={classes.createNewIcon} />
        <Typography className={classes.btnTitle}>
          Create new rate plan
        </Typography>
      </Button>

      <Typography
        variant="body1"
        style={{
          cursor: 'pointer',
          margin: '10px 12px'
        }}
      >
        Select Your Rate Plan
      </Typography>

      <TableContainer
        component={Paper}
        style={{
          marginBottom: '50px'
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Rate Plans</TableCell>
              <TableCell>Start Date</TableCell>
              <TableCell>End Date</TableCell>
              <TableCell>Select</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.activityRatePlans?.map((ratePlan) => {
              const isExpanded = selectedRows[ratePlan.id] || false;

              const groupedPrices = {};

              // Group prices by participant and then currency
              ratePlan.prices.forEach(price => {
                const participant = price.participant.participant;
                const currency = price.currency.currency;
                const value = price.value;

                if (!groupedPrices[participant]) {
                  groupedPrices[participant] = {};
                }

                groupedPrices[participant][currency] = value;
              });

              const startDate = ratePlan.prices[0]?.startDate || '-';
              const endDate = ratePlan.prices[0]?.endDate || '-';

              return (
                <React.Fragment key={ratePlan.id}>
                  <TableRow>
                    <TableCell>
                      <IconButton onClick={() => {
                        setSelectedRows(prev => ({
                          ...prev,
                          [ratePlan.id]: !isExpanded,
                        }));
                      }}>
                        {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                      </IconButton>
                      {ratePlan.title}
                    </TableCell>
                    <TableCell>{startDate}</TableCell>
                    <TableCell>{endDate}</TableCell>
                    <TableCell>
                      <Field
                        name={`selected_${ratePlan.id}`}
                        component={RenderCheckbox}
                        onChange={(e, isChecked) =>
                                  handleRowSelection(ratePlan.id, isChecked)
                                }
                      />
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                        <Box margin={2}>
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell>Category</TableCell>
                                <TableCell>NOK</TableCell>
                                <TableCell>EUR</TableCell>
                                <TableCell>USD</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {Object.keys(groupedPrices).map(participant => (
                                <TableRow key={participant}>
                                  <TableCell>{participant}</TableCell>
                                  <TableCell>{groupedPrices[participant]['NOK'] || '-'}</TableCell>
                                  <TableCell>{groupedPrices[participant]['EUR'] || '-'}</TableCell>
                                  <TableCell>{groupedPrices[participant]['USD'] || '-'}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <FormActionButtons
        cancelPath="/accommodations-and-activities"
        actionLabel="Next"
        setSubmitButton={setSubmitButton}
        isUpdate={isUpdate}
      />
    </form>
  );
};

const mapStateToProps = (state, ownProps) => {
  
  const { existingFutureRatePlanIds } = ownProps;

  const initialValues = {};
  if (existingFutureRatePlanIds && existingFutureRatePlanIds.length) {
    existingFutureRatePlanIds.forEach(id => {
      initialValues[`selected_${id}`] = true;
    });
  }

  return { initialValues,
    activityFuturePricesForm: state.form.activityFuturePricesForm,
    businessOwner: state.businessOwner
   };
};


export default connect(mapStateToProps)(
  reduxForm({
    form: 'activityFuturePricesForm',
    enableReinitialize: true, 
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(ActivityFuturePrices)
);